<script>
import {onMounted, ref, watch} from "vue";
import useSharedData from "@/use/SharedData";
import axios from "axios";

export default {
    props: {
        value: [Number, Array],
        type: String,
        multiple: Boolean,
        label: String,
        readonly: Boolean,
        disabled: Boolean,
        rules: Array,
    },
    setup(props) {
        const {loading, inputColor, backgroundColor} = useSharedData();
        const occupation = ref(null);
        const occupations = ref([]);

        function findAll() {
            axios.get('/importModels', {params: {type: props.type}}).then(response => {
                occupations.value = response.data;
            }).finally(() => {
                loading.value = true;
            })
        }

        watch(() => props.value, () => {
            occupation.value = props.value;
        }, {immediate: true});

        onMounted(() => findAll());

        return {
            occupations,
            occupation,
            loading,
            inputColor,
            backgroundColor
        }
    }
};
</script>

<template>
    <div>
        <v-autocomplete
            v-model="occupation"
            :label="label"
            :items="occupations"
            item-value="id"
            item-text="name"
            outlined
            dense
            :readonly="readonly"
            :disabled="disabled"
            :multiple="multiple"
            :chips="multiple"
            :deletable-chips="multiple"
            :clearable="!readonly"
            :color="inputColor"
            :background-color="backgroundColor"
            hide-details="auto"
            @input="$emit('input', occupation)"
            :rules="rules"
        ></v-autocomplete>

        <input type="hidden"/>
    </div>
</template>